import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "h-250px p-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-hospital fa-4x" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder fs-3 text-white text-hover-white" }, "Add Emergency Contact", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_7 = {
  class: "table table-flush align-middle table-row-bordered table-row-solid gy-4 gs-9",
  "aria-label": "A list of all your emergency contacts."
}
const _hoisted_8 = { class: "fw-6 fw-bold text-gray-600" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "mb-1 fs-3 text-white text-hover-primary" }
const _hoisted_11 = { class: "fw-bold fs-6 text-white" }
const _hoisted_12 = { class: "d-flex justify-content-end border-bottom-0" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fad text-white fa-trash" }, null, -1)
const _hoisted_14 = { class: "d-block d-md-none col-12 col-md-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-plus text-primary mb-5 fs-2x" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "text-white fs-5 fw-bold mb-2" }, "Add Contact", -1)
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_Button = _resolveComponent("Button")!
  const _component_EmergencyContactModal = _resolveComponent("EmergencyContactModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      (_ctx.emergencyContacts.length === 0)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 0,
            description: "It looks like you don't have any emergency contacts."
          }, {
            image: _withCtx(() => [
              _hoisted_3
            ]),
            description: _withCtx(() => [
              _createElementVNode("div", {
                class: "btn btn-primary d-flex flex-column flex-center",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.invokeAddEmergencyContact && _ctx.invokeAddEmergencyContact(...args)))
              }, _hoisted_5)
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("table", _hoisted_7, [
              _createElementVNode("tbody", _hoisted_8, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emergencyContacts, (emergencyContact) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: emergencyContact.emergencyContactId,
                    class: "cursor-pointer"
                  }, [
                    _createElementVNode("td", {
                      onClick: ($event: any) => (_ctx.invokeUpdateEmergencyContact(emergencyContact))
                    }, [
                      _createElementVNode("a", _hoisted_10, _toDisplayString(emergencyContact.name), 1),
                      _createElementVNode("div", _hoisted_11, _toDisplayString(emergencyContact.relationship) + " - " + _toDisplayString(_ctx.formatPhone(emergencyContact.contact)), 1)
                    ], 8, _hoisted_9),
                    _createElementVNode("td", _hoisted_12, [
                      _createVNode(_component_Button, {
                        onClick: ($event: any) => (_ctx.removeContact(emergencyContact.emergencyContactId)),
                        class: "btn-sm btn-light-danger text-white btn-icon"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_13
                        ]),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", {
                class: "d-flex card flex-center bg-light-primary border-primary border border-dashed p-2 pt-4",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.invokeAddEmergencyContact && _ctx.invokeAddEmergencyContact(...args)))
              }, _hoisted_17)
            ])
          ]))
    ])), [
      [_directive_loading, _ctx.isFetching]
    ]),
    _createVNode(_component_EmergencyContactModal, {
      ref: "emergencyContactModal",
      onAdded: _ctx.addToList
    }, null, 8, ["onAdded"])
  ]))
}